import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconPaste = (props) => (
  <SVG
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8333 2.49998H12.35C12 1.53331 11.0833 0.833313 10 0.833313C8.91667 0.833313 8 1.53331 7.65 2.49998H4.16667C3.25 2.49998 2.5 3.24998 2.5 4.16665V17.5C2.5 18.4166 3.25 19.1666 4.16667 19.1666H15.8333C16.75 19.1666 17.5 18.4166 17.5 17.5V4.16665C17.5 3.24998 16.75 2.49998 15.8333 2.49998ZM10 2.49998C10.4583 2.49998 10.8333 2.87498 10.8333 3.33331C10.8333 3.79165 10.4583 4.16665 10 4.16665C9.54167 4.16665 9.16667 3.79165 9.16667 3.33331C9.16667 2.87498 9.54167 2.49998 10 2.49998ZM15.8333 17.5H4.16667V4.16665H5.83333V6.66665H14.1667V4.16665H15.8333V17.5Z"
      fill="#434B5D"
    />
  </SVG>
)

export default withIconStyles(IconPaste)
